import {randString} from "@/utils/libs";
import Storage from "good-storage";
import {removeAdminInfo} from "@/store/cache";

/**
 * storage handler
 */

const UserTokenKey = process.env.VUE_APP_KEY_PREFIX + "Authorization";
const AdminTokenKey = process.env.VUE_APP_KEY_PREFIX + "Admin-Authorization";
const UserRoleKey = process.env.VUE_APP_KEY_PREFIX + "UserRole";
const IsLoginKey = process.env.VUE_APP_KEY_PREFIX + "IsLogin";

export function getSessionId() {
    return randString(42)
}

export function getUserToken() {
    return Storage.get(UserTokenKey) ?? ""
}
export function setUserToken(token) {
    // 刷新 session 缓存
    Storage.set(UserTokenKey, token)
}

export function removeUserToken() {
    Storage.remove(UserTokenKey)
    Storage.remove(UserRoleKey)
    Storage.remove(IsLoginKey)
}

// 用户角色存储
export function getUserRole() {
    return Storage.get(UserRoleKey) ?? null
}
export function setUserRole(role) {
    Storage.set(UserRoleKey, role)
}
export function removeUserRole() {
    Storage.remove(UserRoleKey)
}

// 登录状态存储
export function getIsLogin() {
    return Storage.get(IsLoginKey) ?? false
}
export function setIsLogin(value) {
    Storage.set(IsLoginKey, value)
}
export function removeIsLogin() {
    Storage.remove(IsLoginKey)
}

// 清除所有用户认证信息
export function clearUserAuth() {
    Storage.remove(UserTokenKey)
    Storage.remove(UserRoleKey)
    Storage.remove(IsLoginKey)
}

export function getAdminToken() {
    return Storage.get(AdminTokenKey) ?? ""
}

export function setAdminToken(token) {
    Storage.set(AdminTokenKey, token)
}

export function removeAdminToken() {
    Storage.remove(AdminTokenKey)
    removeAdminInfo()
}